/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LossOfProductionMetricCreateRequest,
  LossOfProductionMetricRepresentation,
  LossOfProductionMetricUpdateRequest,
  LossOfProductionMetricVariantCreateRequest,
  LossOfProductionMetricVariantRepresentation,
  LossOfProductionMetricVariantUpdateRequest,
} from '../models/index';
import {
    LossOfProductionMetricCreateRequestFromJSON,
    LossOfProductionMetricCreateRequestToJSON,
    LossOfProductionMetricRepresentationFromJSON,
    LossOfProductionMetricRepresentationToJSON,
    LossOfProductionMetricUpdateRequestFromJSON,
    LossOfProductionMetricUpdateRequestToJSON,
    LossOfProductionMetricVariantCreateRequestFromJSON,
    LossOfProductionMetricVariantCreateRequestToJSON,
    LossOfProductionMetricVariantRepresentationFromJSON,
    LossOfProductionMetricVariantRepresentationToJSON,
    LossOfProductionMetricVariantUpdateRequestFromJSON,
    LossOfProductionMetricVariantUpdateRequestToJSON,
} from '../models/index';

export interface CreateLossOfProductionMetricRequest {
    lossOfProductionMetricCreateRequest?: LossOfProductionMetricCreateRequest;
}

export interface CreateLossOfProductionMetricVariantRequest {
    metricKey: string;
    lossOfProductionMetricVariantCreateRequest?: LossOfProductionMetricVariantCreateRequest;
}

export interface DeleteLossOfProductionMetricRequest {
    metricKey: string;
}

export interface DeleteLossOfProductionMetricVariantRequest {
    metricKey: string;
    variantKey: string;
}

export interface UpdateLossOfProductionMetricRequest {
    metricKey: string;
    lossOfProductionMetricUpdateRequest?: LossOfProductionMetricUpdateRequest;
}

export interface UpdateLossOfProductionMetricVariantRequest {
    metricKey: string;
    variantKey: string;
    lossOfProductionMetricVariantUpdateRequest?: LossOfProductionMetricVariantUpdateRequest;
}

/**
 * 
 */
export class LossOfProductionMetricApi extends runtime.BaseAPI {

    /**
     * Create a new loss-of-production metric
     */
    async createLossOfProductionMetricRaw(requestParameters: CreateLossOfProductionMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LossOfProductionMetricRepresentation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/loss-of-production-metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LossOfProductionMetricCreateRequestToJSON(requestParameters['lossOfProductionMetricCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LossOfProductionMetricRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new loss-of-production metric
     */
    async createLossOfProductionMetric(lossOfProductionMetricCreateRequest?: LossOfProductionMetricCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LossOfProductionMetricRepresentation> {
        const response = await this.createLossOfProductionMetricRaw({ lossOfProductionMetricCreateRequest: lossOfProductionMetricCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new variant for this loss-of-production metric
     */
    async createLossOfProductionMetricVariantRaw(requestParameters: CreateLossOfProductionMetricVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LossOfProductionMetricVariantRepresentation>> {
        if (requestParameters['metricKey'] == null) {
            throw new runtime.RequiredError(
                'metricKey',
                'Required parameter "metricKey" was null or undefined when calling createLossOfProductionMetricVariant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/loss-of-production-metrics/{metricKey}/variants`;
        urlPath = urlPath.replace(`{${"metricKey"}}`, encodeURIComponent(String(requestParameters['metricKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LossOfProductionMetricVariantCreateRequestToJSON(requestParameters['lossOfProductionMetricVariantCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LossOfProductionMetricVariantRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new variant for this loss-of-production metric
     */
    async createLossOfProductionMetricVariant(metricKey: string, lossOfProductionMetricVariantCreateRequest?: LossOfProductionMetricVariantCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LossOfProductionMetricVariantRepresentation> {
        const response = await this.createLossOfProductionMetricVariantRaw({ metricKey: metricKey, lossOfProductionMetricVariantCreateRequest: lossOfProductionMetricVariantCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Delete a loss-of-production metric
     */
    async deleteLossOfProductionMetricRaw(requestParameters: DeleteLossOfProductionMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['metricKey'] == null) {
            throw new runtime.RequiredError(
                'metricKey',
                'Required parameter "metricKey" was null or undefined when calling deleteLossOfProductionMetric().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/loss-of-production-metrics/{metricKey}`;
        urlPath = urlPath.replace(`{${"metricKey"}}`, encodeURIComponent(String(requestParameters['metricKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a loss-of-production metric
     */
    async deleteLossOfProductionMetric(metricKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLossOfProductionMetricRaw({ metricKey: metricKey }, initOverrides);
    }

    /**
     * Delete a loss-of-production metric variant
     */
    async deleteLossOfProductionMetricVariantRaw(requestParameters: DeleteLossOfProductionMetricVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['metricKey'] == null) {
            throw new runtime.RequiredError(
                'metricKey',
                'Required parameter "metricKey" was null or undefined when calling deleteLossOfProductionMetricVariant().'
            );
        }

        if (requestParameters['variantKey'] == null) {
            throw new runtime.RequiredError(
                'variantKey',
                'Required parameter "variantKey" was null or undefined when calling deleteLossOfProductionMetricVariant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/loss-of-production-metrics/{metricKey}/variants/{variantKey}`;
        urlPath = urlPath.replace(`{${"metricKey"}}`, encodeURIComponent(String(requestParameters['metricKey'])));
        urlPath = urlPath.replace(`{${"variantKey"}}`, encodeURIComponent(String(requestParameters['variantKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a loss-of-production metric variant
     */
    async deleteLossOfProductionMetricVariant(metricKey: string, variantKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLossOfProductionMetricVariantRaw({ metricKey: metricKey, variantKey: variantKey }, initOverrides);
    }

    /**
     * Return all loss-of-production metrics
     */
    async getLossOfProductionMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LossOfProductionMetricRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/loss-of-production-metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LossOfProductionMetricRepresentationFromJSON));
    }

    /**
     * Return all loss-of-production metrics
     */
    async getLossOfProductionMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LossOfProductionMetricRepresentation>> {
        const response = await this.getLossOfProductionMetricsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update a loss-of-production metric
     */
    async updateLossOfProductionMetricRaw(requestParameters: UpdateLossOfProductionMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LossOfProductionMetricRepresentation>> {
        if (requestParameters['metricKey'] == null) {
            throw new runtime.RequiredError(
                'metricKey',
                'Required parameter "metricKey" was null or undefined when calling updateLossOfProductionMetric().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/loss-of-production-metrics/{metricKey}`;
        urlPath = urlPath.replace(`{${"metricKey"}}`, encodeURIComponent(String(requestParameters['metricKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LossOfProductionMetricUpdateRequestToJSON(requestParameters['lossOfProductionMetricUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LossOfProductionMetricRepresentationFromJSON(jsonValue));
    }

    /**
     * Update a loss-of-production metric
     */
    async updateLossOfProductionMetric(metricKey: string, lossOfProductionMetricUpdateRequest?: LossOfProductionMetricUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LossOfProductionMetricRepresentation> {
        const response = await this.updateLossOfProductionMetricRaw({ metricKey: metricKey, lossOfProductionMetricUpdateRequest: lossOfProductionMetricUpdateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Update a loss-of-production metric variant
     */
    async updateLossOfProductionMetricVariantRaw(requestParameters: UpdateLossOfProductionMetricVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LossOfProductionMetricVariantRepresentation>> {
        if (requestParameters['metricKey'] == null) {
            throw new runtime.RequiredError(
                'metricKey',
                'Required parameter "metricKey" was null or undefined when calling updateLossOfProductionMetricVariant().'
            );
        }

        if (requestParameters['variantKey'] == null) {
            throw new runtime.RequiredError(
                'variantKey',
                'Required parameter "variantKey" was null or undefined when calling updateLossOfProductionMetricVariant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/loss-of-production-metrics/{metricKey}/variants/{variantKey}`;
        urlPath = urlPath.replace(`{${"metricKey"}}`, encodeURIComponent(String(requestParameters['metricKey'])));
        urlPath = urlPath.replace(`{${"variantKey"}}`, encodeURIComponent(String(requestParameters['variantKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LossOfProductionMetricVariantUpdateRequestToJSON(requestParameters['lossOfProductionMetricVariantUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LossOfProductionMetricVariantRepresentationFromJSON(jsonValue));
    }

    /**
     * Update a loss-of-production metric variant
     */
    async updateLossOfProductionMetricVariant(metricKey: string, variantKey: string, lossOfProductionMetricVariantUpdateRequest?: LossOfProductionMetricVariantUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LossOfProductionMetricVariantRepresentation> {
        const response = await this.updateLossOfProductionMetricVariantRaw({ metricKey: metricKey, variantKey: variantKey, lossOfProductionMetricVariantUpdateRequest: lossOfProductionMetricVariantUpdateRequest }, initOverrides);
        return await response.value();
    }

}
